import CardGroup from './CardGroup';

// export types
export type { CardGroupProps } from './CardGroup';

// export components
export { CardGroup };
export default CardGroup;
